export const shortcutKeys = {
  META_KEY: "Meta",
  ESCAPE: "Escape",
  SHIFT: "Shift",
  TAB: "Tab",
  CONTROL: "Control",
  FN_KEY1: "F1",
  FN_KEY2: "F2",
  FN_KEY3: "F3",
  FN_KEY4: "F4",
  FN_KEY5: "F5",
  FN_KEY6: "F6",
  FN_KEY7: "F7",
  FN_KEY8: "F8",
  FN_KEY9: "F9",
  FN_KEY10: "F10",
  FN_KEY11: "F11",
  FN_KEY12: "F12",
  ENTER: "Enter",
  ALT: "Alt",
  SPACE: " ",
  BACKSPACE: "Backspace",
  DELETE: "Delete",
  Digit0: "0",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  KeyA: "a",
  KeyB: "b",
  KeyC: "c",
  KeyD: "d",
  KeyE: "e",
  KeyF: "f",
  KeyG: "g",
  KeyH: "h",
  KeyI: "i",
  KeyJ: "j",
  KeyK: "k",
  KeyL: "l",
  KeyM: "m",
  KeyN: "n",
  KeyO: "o",
  KeyP: "p",
  KeyQ: "q",
  KeyR: "r",
  KeyS: "s",
  KeyT: "t",
  KeyU: "u",
  KeyV: "v",
  KeyW: "w",
  KeyX: "x",
  KeyY: "y",
  KeyZ: "z",
  KeyBigA: "A",
  KeyBigB: "B",
  KeyBigC: "C",
  KeyBigD: "D",
  KeyBigE: "E",
  KeyBigF: "F",
  KeyBigG: "G",
  KeyBigH: "H",
  KeyBigI: "I",
  KeyBigJ: "J",
  KeyBigK: "K",
  KeyBigL: "L",
  KeyBigM: "M",
  KeyBigN: "N",
  KeyBigO: "O",
  KeyBigP: "P",
  KeyBigQ: "Q",
  KeyBigR: "R",
  KeyBigS: "S",
  KeyBigT: "T",
  KeyBigU: "U",
  KeyBigV: "V",
  KeyBigW: "W",
  KeyBigX: "X",
  KeyBigY: "Y",
  KeyBigZ: "Z",
  ArrowUp: "ArrowUp",
  ArrowLeft: "ArrowLeft",
  ArrowDown: "ArrowDown",
  ArrowRight: "ArrowRight",
  PLUS: "+",
  MINUS: "-",
  SLASH: "/",
  SPACEBAR: "Space",
}

export function getGlobalKeyMap() {
  let keyMap = {
    SWITCH_TABS: `${shortcutKeys.SHIFT}+${shortcutKeys.TAB}`,
    ESCAPE: `${shortcutKeys.ESCAPE}`,
    FN_KEY1: `${shortcutKeys.FN_KEY1}`,
    FN_KEY2: `${shortcutKeys.FN_KEY2}`,
    FN_KEY3: `${shortcutKeys.FN_KEY3}`,
    FN_KEY4: `${shortcutKeys.FN_KEY4}`,
    FN_KEY5: `${shortcutKeys.FN_KEY5}`,
    FN_KEY6: `${shortcutKeys.FN_KEY6}`,
    FN_KEY7: `${shortcutKeys.FN_KEY7}`,
    FN_KEY8: `${shortcutKeys.FN_KEY8}`,
    FN_KEY9: `${shortcutKeys.FN_KEY9}`,
    FN_KEY10: `${shortcutKeys.FN_KEY10}`,
    LOGOUT: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyL}`,
    LOGOUT_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyBigL}`,
    SWITCH_USER: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyK}`,
    SWITCH_USER_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyBigK}`,
    ENTER: `${shortcutKeys.ENTER}`,
    RISTA_SUPPORT: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyH}`,
    RISTA_SUPPORT_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyBigH}`,
    CTA_PRM: `${shortcutKeys.CONTROL}+${shortcutKeys.ENTER}`,
    CTA_SEC: `${shortcutKeys.CONTROL}+${shortcutKeys.SPACE}`,
    SWITCH_VIEW: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyV}`,
    SWITCH_VIEW_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigV}`,
    CTRL_SHIFT_O: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyO}`,
    CTRL_SHIFT_O_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigO}`,
    CTRL_SHIFT_Q: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyQ}`,
    CTRL_SHIFT_Q_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigQ}`,
    CTRL_SHIFT_W: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyW}`,
    CTRL_SHIFT_W_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigW}`,
    CTRL_SHIFT_A: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyA}`,
    CTRL_SHIFT_A_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigA}`,
    CTRL_SHIFT_S: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyS}`,
    CTRL_SHIFT_S_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigS}`,
    CTRL_SHIFT_I: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyI}`,
    CTRL_SHIFT_I_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigI}`,
    CTRL_SHIFT_R: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyR}`,
    CTRL_SHIFT_R_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigR}`,
    SELECT_ALT1: `${shortcutKeys.ALT}+${shortcutKeys.Digit1}`,
    SELECT_ALT2: `${shortcutKeys.ALT}+${shortcutKeys.Digit2}`,
    SELECT_ALT3: `${shortcutKeys.ALT}+${shortcutKeys.Digit3}`,
    SELECT_ALT7: `${shortcutKeys.ALT}+${shortcutKeys.Digit7}`,
    SELECT_ALT8: `${shortcutKeys.ALT}+${shortcutKeys.Digit8}`,
    SHIFT_UP: `${shortcutKeys.SHIFT}+${shortcutKeys.ArrowUp}`,
    SHIFT_DOWN: `${shortcutKeys.SHIFT}+${shortcutKeys.ArrowDown}`,
    SHIFT_LEFT: `${shortcutKeys.SHIFT}+${shortcutKeys.ArrowLeft}`,
    SHIFT_RIGHT: `${shortcutKeys.SHIFT}+${shortcutKeys.ArrowRight}`,
    CTRL_SHIFT_UP: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.ArrowUp}`,
    CTRL_SHIFT_DOWN: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.ArrowDown}`,
    CTRL_SHIFT_LEFT: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.ArrowLeft}`,
    CTRL_SHIFT_RIGHT: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.ArrowRight}`,
    CTRL_SHIFT_ENTER: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.ENTER}`,
    CTRL_BACKSPACE: `${shortcutKeys.CONTROL}+${shortcutKeys.BACKSPACE}`,
    CTRL_DELETE: `${shortcutKeys.CONTROL}+${shortcutKeys.DELETE}`,
    CTRL_SLASH: `${shortcutKeys.CONTROL}+${shortcutKeys.SLASH}`,
    CTRL_P: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyP}`,
    CTRL_P_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyBigP}`,
    CTRL_Q: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyQ}`,
    CTRL_Q_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyBigQ}`,
    CTRL_1: `${shortcutKeys.CONTROL}+${shortcutKeys.Digit1}`,
    CTRL_2: `${shortcutKeys.CONTROL}+${shortcutKeys.Digit2}`,
    CTRL_3: `${shortcutKeys.CONTROL}+${shortcutKeys.Digit3}`,
    CTRL_4: `${shortcutKeys.CONTROL}+${shortcutKeys.Digit4}`,
    CTRL_SMALLK: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyK}`,
    CTRL_CAPITALK: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyBigK}`,
    ALT_SHIFT_UP: `${shortcutKeys.ALT}+${shortcutKeys.SHIFT}+${shortcutKeys.ArrowUp}`,
    ALT_SHIFT_DOWN: `${shortcutKeys.ALT}+${shortcutKeys.SHIFT}+${shortcutKeys.ArrowDown}`,
    ALT_SHIFT_ENTER: `${shortcutKeys.ALT}+${shortcutKeys.SHIFT}+${shortcutKeys.ENTER}`,
    ALT_SHIFT_KEYR: `${shortcutKeys.ALT}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyR}`,
    ALT_SHIFT_KEYR_BIG: `${shortcutKeys.ALT}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigR}`,
    PLUS: `${shortcutKeys.SHIFT}${shortcutKeys.PLUS}`,
    MINUS: `${shortcutKeys.MINUS}`,
    ARROWUP: `${shortcutKeys.ArrowUp}`,
    ARROWDOWN: `${shortcutKeys.ArrowDown}`,
    ARROWLEFT: `${shortcutKeys.ArrowLeft}`,
    ARROWRIGHT: `${shortcutKeys.ArrowRight}`,
    KeyP: `${shortcutKeys.KeyP}`,
    KeyP_BIG: `${shortcutKeys.KeyBigP}`,
    KeyW: `${shortcutKeys.KeyW}`,
    KeyW_BIG: `${shortcutKeys.KeyBigW}`,
    KeyT: `${shortcutKeys.KeyT}`,
    ALT_BACKSPACE: `${shortcutKeys.ALT}+${shortcutKeys.BACKSPACE}`,
    KeyT_BIG: `${shortcutKeys.KeyBigT}`,
    KeyM: `${shortcutKeys.KeyM}`,
    KeyM_BIG: `${shortcutKeys.KeyBigM}`,
    KeyC: `${shortcutKeys.KeyC}`,
    KeyC_BIG: `${shortcutKeys.KeyBigC}`,
    KeyN: `${shortcutKeys.KeyN}`,
    KeyN_BIG: `${shortcutKeys.KeyBigN}`,
    KeyB: `${shortcutKeys.KeyB}`,
    KeyB_BIG: `${shortcutKeys.KeyBigB}`,
    CTRL_B: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyB}`,
    CTRL_B_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.KeyBigB}`,
    CTRL_SHIFT_C: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyC}`,
    CTRL_SHIFT_C_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigC}`,
    SHIFT_C: `${shortcutKeys.SHIFT}+${shortcutKeys.KeyC}`,
    SHIFT_C_BIG: `${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigC}`,
    KeyE: `${shortcutKeys.KeyE}`,
    KeyBigE: `${shortcutKeys.KeyBigE}`,
    ALT_LEFT : `${shortcutKeys.ALT}+${shortcutKeys.ArrowLeft}` ,
    ALT_D : `${shortcutKeys.ALT}+${shortcutKeys.KeyD}` ,
    ALT_UP : `${shortcutKeys.ALT}+${shortcutKeys.ArrowUp}` ,
    ALT_DOWN : `${shortcutKeys.ALT}+${shortcutKeys.ArrowDown}` ,
    SLASH : `${shortcutKeys.SLASH}`,
    CTRL_SHIFT_P: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyP}`,
    CTRL_SHIFT_P_BIG: `${shortcutKeys.CONTROL}+${shortcutKeys.SHIFT}+${shortcutKeys.KeyBigP}`
  }
  return keyMap;
}

export function checkCtrlSpace(e, type) {
  if (e.ctrlKey && e.key === " ") {
    console.log("ctrlSpace: ", e);
    return true;
  }
  console.log("checkCtrlSpace func: ", e, type);
  return false;
}

export function checkAltNum(e) {
  if (e.altKey && (e.code === "Digit4" || e.code === "Digit5" || e.code === "Digit6" || e.code === "Digit9")) {
    console.log("checkAltNum: ", e);
    return true;
  }
  return false;
}

let AltKeyCombinations = [
  "KeyA",
  "KeyE",
  "KeyX",
  "KeyC",
  "KeyI",
  "KeyU",
  "KeyH",
  "ArrowLeft",
  "KeyD",
];

export function checkAltLetter(e) {
  if (e.altKey && AltKeyCombinations.includes(e.code)) {
    console.log("checkAltLetter: ", e);
    return true;
  }
  return false;
}

export function checkCtrlShiftSpace(e) {
  if (e.ctrlKey && e.shiftKey && e.key === " ") {
    return true;
  }
  return false;
}

export function checkShiftPlusMinus(e) {
  if (e.shiftKey && (e.key === "+" || e.key === "_")) {
    return true;
  }
  return false;
}

export function checkSpace(e) {
  if (
    e.target instanceof HTMLInputElement ||
    e.target instanceof HTMLTextAreaElement
  )
    return false;
  if (e.key === " " && e.code === "Space" && !e.ctrlKey) {
    return true;
  }
  return false;
}

export function checkSlash(e) {
  if (e.key === shortcutKeys.SLASH && e.code === 'Slash' && !e.ctrlKey) {
    return true;
  }
  return false;
}

export function checkControlShiftN(e) {
  if (e.ctrlKey && e.shiftKey && e.key === "N") {
    return true;
  }
  return false;
}